import { Columns } from "@fullscript/aviary-web";
import { useTranslation, Trans } from "react-i18next";

import { SelectableTile, Typography } from "@aviary";
import { l } from "@unauthenticated/oauth/locales/i18n";

import * as styles from "./OAuthLandingTiles.styles";

interface Props {
  isCheckedSignIn: boolean;
  setIsCheckedSignIn: (isCheckedSignIn: boolean) => void;
}

const OAuthLandingTiles = ({ isCheckedSignIn, setIsCheckedSignIn }: Props) => {
  const { t } = useTranslation();

  return (
    <Columns>
      <Columns.Column customCss={styles.tileWrapper} columnWidth={6}>
        <SelectableTile
          checked={isCheckedSignIn}
          onChange={() => {
            setIsCheckedSignIn(true);
          }}
          aria-label={t(l.oauth.SignIn)}
          isRadio
        >
          <div css={styles.tile}>
            <Typography type="h3" css={styles.body}>
              {t(l.oauth.SignIn)}
            </Typography>
            <Typography css={styles.body}>
              <strong>{t(l.oauth.IAlready)}</strong>
            </Typography>
            <Typography type="footnote" css={styles.footnote}>
              {t(l.oauth.ContinueToSignIn)}
            </Typography>
          </div>
        </SelectableTile>
      </Columns.Column>

      <Columns.Column customCss={styles.tileWrapper} columnWidth={6}>
        <SelectableTile
          checked={isCheckedSignIn !== null && !isCheckedSignIn}
          onChange={() => {
            setIsCheckedSignIn(false);
          }}
          aria-label={t(l.oauth.SignUp)}
          isRadio
        >
          <div css={styles.tile}>
            <Typography type="h3" css={styles.body}>
              {t(l.oauth.SignUp)}
            </Typography>
            <Typography css={styles.body}>
              <strong>{t(l.oauth.IAmNewTo)}</strong>
            </Typography>
            <Typography type="footnote" css={styles.footnote}>
              <Trans i18nKey={l.oauth.ContinueToSignUp}>
                Continue to sign up for Fullscript <strong>Free</strong> Services
              </Trans>
            </Typography>
          </div>
        </SelectableTile>
      </Columns.Column>
    </Columns>
  );
};

export { OAuthLandingTiles };
